// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__vJIgm","approved":"Status_approved__11I7l","rejected":"Status_rejected__mvb9C","expired":"Status_expired__3IqrX","label":"Status_label__2KlnA"};